var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aiv-address-autocomplete"},[_c('el-input',{ref:"input",staticClass:"w-100",attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }